import { Immutable } from "immer";
import React from "react";
import { ChatLink } from "tsi-common-react/src/components/ChatLink/index";
import { usePageSetting } from "tsi-common-react/src/utils/settings";
import { usePageURL } from "tsi-common-react/src/utils/urls";

type IProps = Immutable<{
    cartID?: string;
}>;

export const BasketSidebarContent = (_props: IProps) => {
    const contactURL = usePageURL("contact_us_form");
    const homeURL = usePageURL("home");
    const supportPhoneNumberLink = usePageSetting(
        "support_website_phone_number_link",
    );
    const supportPhoneNumberDisplay = usePageSetting(
        "support_website_phone_number_display",
    );
    const phoneLink = (
        <a href={supportPhoneNumberLink || ""}>
            {supportPhoneNumberDisplay || ""}
        </a>
    );
    return (
        <div>
            <div className="basket-summary__help">
                {/* TODO(i18n): Use t tagged template: {t`Questions?`} */}
                <h3>Questions?</h3>
                <div>
                    <p>
                        {/* TODO(i18n): Use jt to keep sentence together with interpolated components: {jt`${chatLink} or call ${phoneLink} and reference ${cartID}`} */}
                        <ChatLink
                            className="basket-summary__help--link"
                            chatOfflineLink={contactURL || homeURL}
                        />
                        {" or "} <span>Call {phoneLink}</span>
                        <br />
                        {" and reference "}
                        <strong>{_props.cartID}</strong>
                    </p>
                </div>
            </div>
        </div>
    );
};
